import { Link } from 'react-router';

import { Box, Text } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import type { StaticImageData } from 'Components/Image';
import { Button } from 'Components/LegacyButton';
import { Typography } from 'Components/Typography';

import { BackgroundNextImage, type Devices } from 'Blocks/BackgroundNextImage';

const Root = styled.div`
  width: 100%;
  max-width: 450px;

  ${legacyTheme.breakpoints.up('sm')} {
    max-width: 624px;
  }
`;

const ImageContainer = styled.div`
  aspect-ratio: 1/ 1;

  ${legacyTheme.breakpoints.up('md')} {
    aspect-ratio: 2 / 1.5;
  }

  ${legacyTheme.breakpoints.up('lg')} {
    aspect-ratio: 2 / 1.2;
  }
`;

const Title = styled(Typography)`
  margin-bottom: 24px;
  max-width: 270px;
`;

type ProductsFeaturedProps = {
  image: {
    alt: string;
    src: Devices<StaticImageData>;
  };
  ctaLabel: string;
  title: string;
  url: string;
  underButtonTextLabel?: string;
  dataClick?: string;
  dataFrom?: string;
};

export const ProductsFeatured = ({
  dataClick,
  dataFrom,
  url,
  image,
  ctaLabel,
  title,
  underButtonTextLabel,
}: ProductsFeaturedProps) => (
  <Root>
    <ImageContainer>
      <BackgroundNextImage
        fill
        image={image.src}
        imageAlt={image.alt}
        sizebydevice={{ mobile: '100vw', tablet: '50vw', desktop: '50vw' }}
      >
        <Box
          alignItems="center"
          display="flex"
          flexDirection="column"
          gap="5x"
          height="full"
          justifyContent="center"
          width="full"
        >
          <Title align="center" color="white" variant="h2">
            {title}
          </Title>

          <Box display="flex" flexDirection="column" gap="5x">
            <Button
              Component={Link}
              data-click={dataClick}
              data-from={dataFrom}
              noMargin
              to={url}
              variant="whiteBg"
            >
              {ctaLabel}
            </Button>
            {underButtonTextLabel && (
              <Text color="neutral.100" variant="bodyMd">
                {underButtonTextLabel}
              </Text>
            )}
          </Box>
        </Box>
      </BackgroundNextImage>
    </ImageContainer>
  </Root>
);
